import { ROLE } from 'app/cart/constants';
import { ValidationError } from '@shared/services';

export type ErrorReturnType = Record<
    (typeof ROLE)[keyof typeof ROLE],
    Partial<Record<keyof CartAddressDeliveryBase, string>>
>;

export function handleSubmitError(error: Error) {
    let errors: ErrorReturnType | null = null;

    let role: ROLE | null = null;

    let field: keyof CartAddressDeliveryBase | null = null;

    if (error instanceof ValidationError) {
        const details = error.context.detail;

        errors = {} as ErrorReturnType;

        if (Array.isArray(details)) {
            for (let i = 0; i < details.length; i++) {
                const errorField = details[i];

                const [, _role, , _field] = errorField.loc;

                if (!errors[_role]) {
                    errors[_role] = {};
                }

                errors[_role][_field] = errorField.msg;

                if (!role) {
                    role = _role as ROLE;
                }

                if (!field) {
                    field = _field as keyof CartAddressDeliveryBase;
                }
            }
        }
    }

    return { errors, role, field };
}
